import View from '@shared/components/layout-default/layout-default-router-view';
import OperatorView from '@pbx/pages/operators';

export const sip_accounts = [
  {
    path: 'sip-accounts',
    component: OperatorView,
    children: [
      {
        path: '',
        name: 'pbx.sip-account.index',
        component: () =>
          import(
            /* webpackChunkName: 'pbx-sip-accounts' */
            '@pbx/pages/operators/sip-accounts'
          ),
        meta: {
          title: {
            code: 'pbx.breadcrumb.sip-account.index'
          }
        }
      }
    ]
  },

  {
    path: 'sip-accounts',
    component: View,
    children: [
      {
        path: 'new',
        name: 'pbx.sip-account.create',
        component: () =>
          import(
            /* webpackChunkName: 'pbx-sip-accounts' */
            '@pbx/pages/operators/sip-accounts/create'
          ),
        meta: {
          title: { code: 'pbx.breadcrumb.sip-account.create' }
        }
      }
    ]
  }
];
